<template>
  <v-layout row wrap justify-start ma-2 justify-center>
    <v-flex md3 v-for="feature of featuresList" :key="feature.value">
      <v-layout row wrap>
        <v-flex md3>
          <div class="dt-checkbox v2">
            <input type="checkbox" 
            :name="feature.value" 
            :id="feature.value" 
            :checked="isChecked(feature.value)"
            @click="e => onfeatureSelected(e, feature)"
          >
            <div class="checkmark"></div>
            <!-- <div 
              class="checkmark"
              :style="{
                'backgroundColor': feature.color,
                'borderColor': feature.borderColor
              }"
            ></div> -->
          </div>
        </v-flex>
        <v-flex md9>
          <div class="month-text txtov" :title="feature.text">
            {{feature.text}}
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import randomColor from 'randomcolor';

export default {
  props: {
    feature: {
      type: String,
      required: true,
      default: () => '',
    }
  },
  data: function() {
    return {
      features: [
         'Shower',
         'Videoprojector',
         'Wardrobe',
         'Touroffice',	 
         'Backline',	 
         'Backstage',
         'Internet',
         'Kitchen',
      ],
      selectedfeaturesList: new Set()
    }
  },
  computed: {
    featuresList: function() {
      return this.features.map(e => {
        return {
          text: e,
          value: e,
          color: randomColor({
            luminosity: 'dark',
            format: 'rgb'
          }),
          borderColor: randomColor({
            luminosity: 'light',
            format: 'rgba'
          })
        } 
      })
    }
  },
  methods: {
    onfeatureSelected: function(e, feature) {
      // console.log(e, feature);
      this.$emit('change', 
        e.target.checked ? 
          (
            this.isChecked(feature.value) ? 
            `${this.feature}`
            :`${this.feature}${feature.value}`) : 
          `${this.feature}`.replace(`${feature.value}`, ``)
      );
    },
    isChecked: function(feature) {
      return this.feature.indexOf(feature) > -1;
    }
  }
}
</script>

<style>

</style>
